import React, { useState, useRef, useEffect } from "react";
import "./Itinerary.css";
import Lottie from "lottie-react";
import churchAnimation from "../../json-lottie/Church.json";
import cocktailAnimation from "../../json-lottie/Cocktail.json";
import diningAnimation from "../../json-lottie/Dinner.json";
import { useLanguage } from "../../context/LanguageContext";


const Itinerary = () => {
  const { t } = useLanguage();
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const cardContainerRef = useRef(null);

  const scrollToCard = (index) => {
    if (cardContainerRef.current) {
      const cards = cardContainerRef.current.querySelectorAll('.card');
      if (cards[index]) {
        cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        setCurrentCardIndex(index);
      }
    }
  };

  // Track which card is in view
  useEffect(() => {
    if (!cardContainerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const cards = Array.from(cardContainerRef.current.querySelectorAll('.card'));
            const index = cards.indexOf(entry.target);
            if (index !== -1) {
              setCurrentCardIndex(index);
            }
          }
        });
      },
      { threshold: 0.5, root: cardContainerRef.current }
    );

    const cards = cardContainerRef.current.querySelectorAll('.card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);
  return (
    <div className="parent-container">
      <div className="itinerary">
        <h2>{t.itinerary_title}</h2>
      </div>
      <div className="card-container" ref={cardContainerRef}>
        {/* Navigation Arrows */}
        {currentCardIndex > 0 && (
          <button
            className="nav-arrow left"
            onClick={() => scrollToCard(currentCardIndex - 1)}
            aria-label="Previous card"
          >
            &#10094;
          </button>
        )}

        {currentCardIndex < 2 && (
          <button
            className="nav-arrow right"
            onClick={() => scrollToCard(currentCardIndex + 1)}
            aria-label="Next card"
          >
            &#10095;
          </button>
        )}

        {/* Card 1 */}
        <div className="card">
          <div className="card-title">{t.itinerary_church_title}</div>
          <Lottie animationData={churchAnimation} style={{ width: 190, height: 120 }} />
          <p className="card-time">{t.itinerary_church_time}</p>
          <h1 className="card-header1">{t.itinerary_church_location}</h1>
          <h3 className="card-header2">{t.itinerary_church_address}</h3>
          <button
            className="card-button"
            onClick={() => window.open("https://maps.app.goo.gl/cnEYxhg39shuPgLh8", "_blank")}
          >
            Abrir en Google Maps
          </button>
        </div>
        {/* Card 2 */}
        <div className="card">
          <div className="card-title">{t.itinerary_cocktail_title}</div>
          <Lottie animationData={cocktailAnimation} style={{ width: 190, height: 120 }} />
          <p className="card-time">{t.itinerary_cocktail_time}</p>
          <h1 className="card-header1">{t.itinerary_cocktail_location}</h1>
          <h3 className="card-header2">{t.itinerary_cocktail_address}</h3>
          <button
            className="card-button"
            onClick={() => window.open("https://maps.app.goo.gl/aHzKHP6RdwB1udsC8", "_blank")}
          >
            Abrir en Google Maps
          </button>
        </div>
        {/* Card 3 */}
        <div className="card">
          <div className="card-title">{t.itinerary_dining_title}</div>
          <Lottie animationData={diningAnimation} style={{ width: 190, height: 120 }} />
          <p className="card-time">{t.itinerary_dining_time}</p>
          <h1 className="card-header1">{t.itinerary_dining_location}</h1>
          <h3 className="card-header2">{t.itinerary_dining_address}</h3>
          <button
            className="card-button"
            onClick={() => window.open("https://maps.app.goo.gl/aHzKHP6RdwB1udsC8", "_blank")}
          >
            {t.itinerary_googlemaps}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Itinerary;